"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomWithPropertyAndStructureType = void 0;
var RoomCount_1 = require("./RoomCount");
exports.RoomWithPropertyAndStructureType = {
    hy: {
        sell: {
            apartment: (_a = {},
                _a[RoomCount_1.ROOM_COUNT.ONE] = '1-senyakanoc-norakaruic-bnakaran-',
                _a[RoomCount_1.ROOM_COUNT.TWO] = '2-senyakanoc-norakaruic-bnakaran-',
                _a[RoomCount_1.ROOM_COUNT.TREE] = '3-senyakanoc-norakaruic-bnakaran-',
                _a[RoomCount_1.ROOM_COUNT.FOUR] = '4-senyakanoc-norakaruic-bnakaran-',
                _a),
            house: (_b = {},
                _b[RoomCount_1.ROOM_COUNT.ONE] = '1-senyakanoc-norakaruic-sepakan-tun-',
                _b[RoomCount_1.ROOM_COUNT.TWO] = '2-senyakanoc-norakaruic-sepakan-tun-',
                _b[RoomCount_1.ROOM_COUNT.TREE] = '3-senyakanoc-norakaruic-sepakan-tun-',
                _b[RoomCount_1.ROOM_COUNT.FOUR] = '4-senyakanoc-norakaruic-sepakan-tun-',
                _b),
        },
        rent: {
            apartment: (_c = {},
                _c[RoomCount_1.ROOM_COUNT.ONE] = '1-senyakanoc-norakaruic-bnakaran-',
                _c[RoomCount_1.ROOM_COUNT.TWO] = '2-senyakanoc-norakaruic-bnakaran-',
                _c[RoomCount_1.ROOM_COUNT.TREE] = '3-senyakanoc-norakaruic-bnakaran-',
                _c[RoomCount_1.ROOM_COUNT.FOUR] = '4-senyakanoc-norakaruic-bnakaran-',
                _c),
            house: (_d = {},
                _d[RoomCount_1.ROOM_COUNT.ONE] = '1-senyakanoc-norakaruic-arandznatun-',
                _d[RoomCount_1.ROOM_COUNT.TWO] = '2-senyakanoc-norakaruic-arandznatun-',
                _d[RoomCount_1.ROOM_COUNT.TREE] = '3-senyakanoc-norakaruic-arandznatun-',
                _d[RoomCount_1.ROOM_COUNT.FOUR] = '4-senyakanoc-norakaruic-arandznatun-',
                _d),
        },
    },
    ru: {
        sell: {
            apartment: (_e = {},
                _e[RoomCount_1.ROOM_COUNT.ONE] = '1-komnatnaya-kvartira-v-novostroike-',
                _e[RoomCount_1.ROOM_COUNT.TWO] = '2-komnatnaya-kvartira-v-novostroike-',
                _e[RoomCount_1.ROOM_COUNT.TREE] = '3-komnatnaya-kvartira-v-novostroike-',
                _e[RoomCount_1.ROOM_COUNT.FOUR] = '4-komnatnaya-kvartira-v-novostroike-',
                _e),
            house: (_f = {},
                _f[RoomCount_1.ROOM_COUNT.ONE] = '1-komnatniy-chastniy-dom-novostroika-',
                _f[RoomCount_1.ROOM_COUNT.TWO] = '2-komnatniy-chastniy-dom-novostroika-',
                _f[RoomCount_1.ROOM_COUNT.TREE] = '3-komnatniy-chastniy-dom-novostroika-',
                _f[RoomCount_1.ROOM_COUNT.FOUR] = '4-komnatniy-chastniy-dom-novostroika-',
                _f),
        },
        rent: {
            apartment: (_g = {},
                _g[RoomCount_1.ROOM_COUNT.ONE] = '1-komnatnaya-kvartira-v-novostroike-',
                _g[RoomCount_1.ROOM_COUNT.TWO] = '2-komnatnaya-kvartira-v-novostroike-',
                _g[RoomCount_1.ROOM_COUNT.TREE] = '3-komnatnaya-kvartira-v-novostroike-',
                _g[RoomCount_1.ROOM_COUNT.FOUR] = '4-komnatnaya-kvartira-v-novostroike-',
                _g),
            house: (_h = {},
                _h[RoomCount_1.ROOM_COUNT.ONE] = '1-komnatniy-chastniy-dom-novostroika-',
                _h[RoomCount_1.ROOM_COUNT.TWO] = '2-komnatniy-chastniy-dom-novostroika-',
                _h[RoomCount_1.ROOM_COUNT.TREE] = '3-komnatniy-chastniy-dom-novostroika-',
                _h[RoomCount_1.ROOM_COUNT.FOUR] = '4-komnatniy-chastniy-dom-novostroika-',
                _h),
        },
    },
    en: {
        sell: {
            apartment: (_j = {},
                _j[RoomCount_1.ROOM_COUNT.ONE] = '1-room-new-apartment-',
                _j[RoomCount_1.ROOM_COUNT.TWO] = '2-room-new-apartment-',
                _j[RoomCount_1.ROOM_COUNT.TREE] = '3-room-new-apartment-',
                _j[RoomCount_1.ROOM_COUNT.FOUR] = '4-room-new-apartment-',
                _j),
            house: (_k = {},
                _k[RoomCount_1.ROOM_COUNT.ONE] = '1-room-new-house-',
                _k[RoomCount_1.ROOM_COUNT.TWO] = '2-room-new-house-',
                _k[RoomCount_1.ROOM_COUNT.TREE] = '3-room-new-house-',
                _k[RoomCount_1.ROOM_COUNT.FOUR] = '4-room-new-house-',
                _k),
        },
        rent: {
            apartment: (_l = {},
                _l[RoomCount_1.ROOM_COUNT.ONE] = '1-room-new-apartment-',
                _l[RoomCount_1.ROOM_COUNT.TWO] = '2-room-new-apartment-',
                _l[RoomCount_1.ROOM_COUNT.TREE] = '3-room-new-apartment-',
                _l[RoomCount_1.ROOM_COUNT.FOUR] = '4-room-new-apartment-',
                _l),
            house: (_m = {},
                _m[RoomCount_1.ROOM_COUNT.ONE] = '1-room-new-house-',
                _m[RoomCount_1.ROOM_COUNT.TWO] = '2-room-new-house-',
                _m[RoomCount_1.ROOM_COUNT.TREE] = '3-room-new-house-',
                _m[RoomCount_1.ROOM_COUNT.FOUR] = '4-room-new-house-',
                _m),
        },
    },
};
